import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaBan } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { markPaymentReceiptAsCancelled } from '../../../../../../../../../../crud/payments_api/payment_receipts';
import './CancelReceipt.scss';

interface CancelReceiptProps {
  show: boolean;
  onClose: () => void;
  receiptId: number;
  onSuccess?: () => void;
}

const CancelReceipt: React.FC<CancelReceiptProps> = ({
  show,
  onClose,
  receiptId,
  onSuccess
}) => {
  const [cancelComment, setCancelComment] = useState<string>('');
  const [cancellingReceipt, setCancellingReceipt] = useState<boolean>(false);

  const handleClose = () => {
    setCancelComment('');
    onClose();
  };

  const handleCancelReceipt = async () => {
    if (!cancelComment.trim()) {
      toast.error('Debe ingresar un comentario para cancelar el recibo');
      return;
    }

    setCancellingReceipt(true);
    try {
      await markPaymentReceiptAsCancelled(receiptId, cancelComment);
      toast.success('Recibo cancelado');
      handleClose();
      
      if (onSuccess) {
        onSuccess();
      } else {
        setTimeout(() => {
          window.location.reload();
        }, 300);
      }
    } catch (error) {
      console.error('Error cancelling receipt: ', error);
      toast.error('Error al cancelar el recibo');
    } finally {
      setCancellingReceipt(false);
    }
  };

  return (
    <Modal 
      show={show} 
      onHide={handleClose}
      centered
      className="cancel-receipt-modal"
    >
      <Modal.Header>
        <Modal.Title>
          <FaBan style={{ color: '#dc2626', marginRight: '8px' }} />
          Cancelar Recibo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="cancel-receipt-content">
          <p className="cancel-warning">
            Esta acción cancelará permanentemente el recibo <strong>#{receiptId}</strong>.
          </p>
          <Form.Group className="mb-3">
            <Form.Label className="required-label">
              Motivo de cancelación <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Ingrese el motivo de la cancelación (obligatorio)"
              value={cancelComment}
              onChange={(e) => setCancelComment(e.target.value)}
              disabled={cancellingReceipt}
              className={!cancelComment.trim() && cancelComment !== '' ? 'is-invalid' : ''}
            />
            <Form.Text className="text-muted">
              Este comentario quedará registrado en el historial del recibo.
            </Form.Text>
          </Form.Group>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={handleClose}
          disabled={cancellingReceipt}
        >
          Volver
        </Button>
        <Button 
          variant="danger" 
          onClick={handleCancelReceipt}
          disabled={!cancelComment.trim() || cancellingReceipt}
        >
          {cancellingReceipt ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Cancelando...
            </>
          ) : (
            <>
              <FaBan style={{ marginRight: '6px' }} />
              Confirmar Cancelación
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelReceipt;
